class AppearList {
    constructor() {
        this.observers = [];

        this.init();

        // Bind the debounce function to the instance
        this.debouncedResizeHandler = this.debounce(() => {
            // this.clear();
            this.init();
        }, 200);

        window.addEventListener('resize', this.debouncedResizeHandler);
    }

    // Utility function to debounce a given function
    debounce(func, wait) {
        let timeout;
        return (...args) => {
            clearTimeout(timeout);
            timeout = setTimeout(() => func.apply(this, args), wait);
        };
    }

    // Function to initialise intersection observers and animations for each item container
    init() {
        // Clear existing observers
        this.observers.forEach(observer => observer.disconnect());
        this.observers = [];

        const listContainers = document.querySelectorAll('[data-appear-list]');

        listContainers.forEach(container => {
            const listItems = container.querySelectorAll('.appear-item');

            const observer = new IntersectionObserver((entries, observer) => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        listItems.forEach((item, index) => {
                            item.classList.add('_visible');
                            item.style.transitionDelay = `${index * 0.08}s`;
                        });
                        observer.unobserve(entry.target);
                    }
                });
            }, {
                threshold: 0.75 // Adjust threshold as needed (0-1)
            });

            observer.observe(container);
            this.observers.push(observer);
        });
    }

    // Function to clear animations
    clear() {
        this.observers.forEach(observer => observer.disconnect());
        this.observers = [];
        const listItems = document.querySelectorAll('.appear-item');

        listItems.forEach(item => {
            item.classList.remove('_visible');
            item.style.transitionDelay = '';
        });
    }

    // Method to destroy event listeners and observers
    destroy() {
        window.removeEventListener('resize', this.debouncedResizeHandler);
        this.clear();
    }
}

export default new AppearList();
